import React from 'react';

function ShowHoc({ condition, children }) {
  return condition ? children : null;
}

export default ShowHoc;
